import { render, staticRenderFns } from "./modal-auth.vue?vue&type=template&id=0c9ada83&"
import script from "./modal-auth.vue?vue&type=script&lang=js&"
export * from "./modal-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports